import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DisplayableMediaStruct } from '../../services/structs/user/displayable-media.struct';
import { MediaTypeEnum } from '../../enum/media-type.enum';

@Component({
  selector: 'app-media-display',
  templateUrl: './media-display.component.html',
  styleUrls: ['./media-display.component.css']
})

export class MediaDisplayComponent implements OnInit {
  @Input() public mediaSources: DisplayableMediaStruct[] = [];
  @Input() public refreshTime: number | null = null;
  @Output() public refresh: EventEmitter<any> = new EventEmitter();
  public sourceUrl: string = '';
  public videoDisplay: boolean = false;
  public imageDisplay: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.refreshTime)
      return;
    if (changes['mediaSources'] && this.mediaSources.length > 0) {
      this.mediaSources.sort((a, b) => (a.order! + 1) - (b.order! + 1));
      this.playNextMedia();
      setTimeout(() => {
        this.refresh.emit();
      }, this.refreshTime);
    }
  }

  ngOnInit() {
    if (!this.mediaSources || this.mediaSources.length == 0 || !this.refreshTime)
      return;

    setTimeout(() => {
      this.refresh.emit();
    }, this.refreshTime);

    this.sourceUrl = this.mediaSources[0].sourceUrl;
  }

  playNextMedia() {
    const endedMedia = this.mediaSources.shift();
    if (endedMedia)
      this.mediaSources.push(endedMedia);
    const nextMedia = this.mediaSources[0];

    this.sourceUrl = nextMedia.sourceUrl;
    if (nextMedia.mediaType == MediaTypeEnum.Video) {
      this.videoDisplay = true;
      this.imageDisplay = false;
      this.loadAndPlay();
    }

    else if (nextMedia.mediaType == MediaTypeEnum.Image) {
      this.imageDisplay = true;
      this.videoDisplay = false;
      const delay = (nextMedia.screenSeconds ? nextMedia.screenSeconds : 1) + 1;
      setTimeout(() => {
        this.playNextMedia();
      }, delay * 1000);
    }
  }

  loadAndPlay() {
    var myVideo: any = document.getElementById("video");
    if (!myVideo)
      return;
    myVideo.currentTime = 0;
    myVideo.load();
    myVideo.play();
  }

  pause() {
    var myVideo: any = document.getElementById("video");
    if (!myVideo)
      return;
    myVideo.pause();
  }

  resume() {
    var myVideo: any = document.getElementById("video");
    if (!myVideo)
      return;
    myVideo.play();
  }

  replay() {
    var myVideo: any = document.getElementById("video");
    if (!myVideo)
      return;
    myVideo.curretTime = 0;
    myVideo.play();
  }
  img_loaded() {}
}